import {
  configureStore,
  combineReducers,
  createImmutableStateInvariantMiddleware
} from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import storageSession from 'redux-persist/lib/storage/session'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'

import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'
import thunk from 'redux-thunk'
import {
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary
} from './globalNotary'
import { persistReducer } from './redux.Interface.Common'
import listenerMiddlewareExecuter from './listenerMiddlewareExecutor'
import { apiContainer } from '../features/apiSlice/apiContainer'

/// /////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////
/// /    ⠂⠀⠀⠀⠀⠀⠠⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⣀⣀⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⢻⡖⠚⢿⣛⢦⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣀⣀⣹⣎⢆⠻⣷⡻⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠿⣟⠿⣿⣿⣏⢧⢻⣷⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⠺⣥⣽⣬⢦⠛⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣤⠤⠖⠚⠛⠋⠉⣝⠉⠉⢩⡙⠛⠒⠦⠤⣤⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣠⠖⠋⣉⠀⠀⠀⠀⠀⠀⠀⠋⠳⠺⠉⠀⠀⠀⠀⠀⠀⠉⠉⠲⢦⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣾⡭⠆⣠⠖⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠰⢮⣷⠄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⡾⠇⣠⡜⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⢳⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣴⠋⠀⣰⢿⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣠⡌⢷⡀⠀⠀⠀⠀⠀⠀⠀
/// /   ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢾⡿⠁⠀⠁⢸⣿⣿⣶⣶⣤⣄⣀⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣀⣀⣦⣴⣶⣶⣿⣿⠁⠀⢳⡀⠀⠀⠀⠀⠀⠀
/// /   ⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⡾⠀⡠⠀⠀⢸⣿⣿⣿⣿⣿⣿⣿⣿⣷⣶⣦⣄⡀⠀⢄⣤⣴⣶⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠀⠀⠀⣷⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⣾⠀⣠⢣⡇⠀⠘⠛⠻⠿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡏⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠿⠛⠃⠀⠀⣜⡆⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⣸⠁⠀⠃⣾⠇⢠⡄⠀⣠⠏⠀⠀⠉⡝⣿⣿⡿⢿⣿⣿⠇⣿⣿⣿⣿⣿⡿⠿⡛⠋⠁⢹⡄⠀⠀⢰⠀⠀⢿⠟⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⡟⠀⡆⠀⡏⠀⢸⠀⠀⢻⡀⠀⠀⠀⢻⣻⣿⣿⠆⢈⠉⠀⠉⢫⢡⡸⠿⢿⣿⠃⠀⠀⠈⡇⠀⠀⢸⡄⠀⠈⣧⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⢸⠃⢰⠀⠀⡇⠀⠸⣆⠀⠀⠳⣄⠀⠀⠀⠈⠉⢁⣠⢞⣀⡴⣦⡸⡆⠙⠓⠛⠉⠀⠀⠀⣰⠇⠀⠀⢸⡇⡆⠀⢹⡀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠰⣿⠀⣾⠀⠀⣿⠀⠀⠈⠣⣄⣀⠀⠙⠓⠒⠒⠛⢉⡴⠋⠀⣠⠀⠙⢞⠧⣤⣀⣀⣀⣤⠴⠃⠀⠀⢀⡿⠀⣇⠀⠀⣧⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⣿⠀⡏⠀⠀⠇⠀⠀⠀⠀⠀⠀⠉⠉⠀⢀⡠⠖⠁⠀⠀⠀⣻⠀⠀⠈⢣⡀⠀⠠⣄⣀⣀⣀⣠⠴⠋⠀⠀⢻⡀⠀⢻⡄⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⢸⡏⢠⢀⡆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠰⣯⣅⣀⠀⠀⠀⠀⠸⡄⠀⠀⠀⠹⣦⠀⠀⠉⠉⠉⠀⠀⠀⠀⠀⠀⣇⠀⠸⡇⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⢸⠁⢸⣾⡿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠳⣍⠛⠲⣤⣀⡀⠃⣀⣠⣤⡄⢸⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡿⠀⠀⡇⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⡎⠀⢸⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⠢⣄⡀⠉⠉⣀⡤⠴⠛⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢰⣽⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⢸⠇⠀⢸⠀⢠⠆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⢩⠉⠉⠀⠀⠀⠀⠀⠀⠀⠳⢄⡀⠀⠀⠀⠀⠀⠀⠀⠘⡏⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⡞⠀⣀⡀⠀⣼⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⣆⠀⠀⠀⠀⠀⠀⡆⡇⠀⠀⠀
/// /    ⠀⠀⠀⠀⢸⠇⠸⠛⠋⠀⣧⠀⠀⠀⠀⠀⠀⠀⠀⢠⡀⠀⠀⠀⠀⠀⣀⠀⠀⠘⠀⠀⢠⡀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠓⢆⠀⠀⠀⠀⡟⢧⠀⠀⠀
/// /    ⠀⠀⠀⢠⡏⠀⡀⠀⠀⢀⣷⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠛⠛⠒⠀⠀⠈⠓⠦⠤⠤⠤⠀⠙⠛⠛⠋⠀⠀⠛⠦⠄⠀⠀⠀⠙⣆⠀⢠⠁⢸⡆⠀⠀
/// /    ⠀⠀⠀⡞⠀⢸⢧⡀⠀⢸⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡀⠀⠀⠀⠀⠀⠤⣀⡀⠀⠀⠀⠀⠀⠙⢠⣼⠀⠀⢳⠀⠀
/// /    ⠀⠀⣼⠇⠀⠀⠀⠀⠀⠸⢸⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠘⠦⣤⣀⣀⠀⠀⠀⠙⠲⠶⠦⠶⠂⠀⠀⠉⢀⠀⠀⠀⠀⢀⠏⡿⠀⠀⢸⡇⠀
/// /    ⠀⢠⡏⠀⠀⠀⠀⠀⠀⠀⢺⡆⠀⠀⠀⠀⠀⠀⠀⠘⢦⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢤⣀⡀⠀⠀⠀⠀⠙⠓⠀⠀⡿⢀⠇⠀⠀⠀⡇⠀
/// /    ⠀⣼⠀⠀⠀⠀⠀⠀⠀⠀⠀⣧⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠉⠉⠀⠀⠀⠀⠻⢤⣄⣀⣠⡤⠀⠀⠀⠀⠉⠀⠀⠀⠀⠂⠀⠀⠁⣼⠀⠟⠛⠀⢳⠀
/// /    ⠀⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⣿⣄⠀⠀⠀⠀⡀⠀⠀⠀⠀⣀⠀⠀⠀⢀⡀⠀⠀⠀⣀⠀⠀⠀⠀⠐⠶⠤⠀⠀⠀⠀⠀⠀⠀⠀⣾⠀⠀⠀⠀⣼⠀
/// /    ⠀⢻⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⡿⣄⠀⠀⠀⢳⡀⠀⠀⠀⠈⠉⠀⠀⠀⠀⠀⠀⠀⠈⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣤⣿⠀⠀⠀⣠⢿⡇
/// /    ⠀⠸⡇⠀⠀⠀⠀⠀⠀⡀⠀⠈⣧⠙⣆⠀⠀⠀⠻⡀⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⠄⠀⠀⢹⡟⡆⠀⡼⠁⢸⠇
/// /    ⠀⠀⠻⡾⡆⡀⠀⠀⠀⡟⢦⣠⠇⠀⠘⢧⡀⠀⠀⠉⠉⣧⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⡄⠀⣼⣠⣿⠞⠁⣰⠏⠀
/// /    ⠀⠀⠀⠳⣷⡱⡆⠀⠀⢷⡀⠀⠀⢆⣰⢀⠙⣄⠀⠀⠀⠀⠉⠳⠶⢦⣀⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣠⠾⠋⠀⢸⠻⠭⠤⠔⠊⠁⠀⠀
/// /    ⠀⠀⠀⠀⠈⠓⠻⣦⣤⣤⡟⠀⠀⠸⠛⢺⡀⠈⢧⡀⠀⠀⠀⠀⠀⠀⠉⠉⠒⠒⠉⠀⠀⠀⠀⠀⠀⠀⣠⡴⠋⠁⠀⠀⢀⣼⢐⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢷⡀⠀⠃⠀⠀⠀⠀⠀⠙⢦⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣠⡤⠖⠛⠁⠀⢠⣀⣤⣄⣺⣿⠸⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⢻⡀⠀⠀⣦⣀⡀⠀⠀⠀⠈⠙⠲⠶⠶⠶⠶⠶⠶⠛⠛⢩⡉⡀⠀⠀⠀⠀⠈⠛⠃⠀⣴⡿⠉⠀⠀⠀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠳⣄⠀⠉⠁⠀⠀⠀⠀⢀⡼⠂⠀⠀⠀⠀⠀⠀⠀⠀⠈⢹⣷⢦⣤⣀⠀⣀⣀⣰⡾⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// /   ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠛⠦⣴⠶⠶⢲⡚⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣀⣀⣠⡴⠉⠈⢻⣁⣉⣋⣀⣤⣤⣤⣄⣀⡀⠀⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⠤⢖⣖⡦⠼⠴⢤⣀⣷⣲⣤⡀⠀⠀⠀⠀⠀⢠⠞⢁⢤⡙⡟⣇⠀⢶⠟⡾⣷⣆⡈⢉⢳⣇⣬⠛⣿⡄⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡾⠥⢽⡑⣠⢔⣒⡀⢀⡇⠀⢩⠉⢹⡇⠀⠀⠀⠀⠈⠛⠾⠟⠛⠛⠛⠷⠦⠤⣼⣃⣋⣼⣁⣀⡿⠭⠶⠿⠃⠀⠀⠀⠀
/// /    ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠛⠒⠒⠛⠙⠶⠤⠿⠟⠑⠶⠿⠽⠟⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠉⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀
/// ////////////////////////////////////////////////////////////////////////////////////////////
/// //  PLEASE IMPORT YOUR SLICE REDUCERS HERE, CALL COMBINE REDUCER IN YOUR OWN SLICE, ONE  ///
/// //  STANDARD MODULE WILL ONLY ADD TWO LINES IN THIS FILE, NO MERGE CONFLICTS OF ANY KIND ///
/// ////////////////////////////////////////////////////////////////////////////////////////////

import dynamicFieldsMiddleware from '../features/dynamictabs/reducers/middleware'
import signInSignoutReducers from '../features/signinsignout/reducers/index' /// <<== HERE
import dynamicTabsReducers from '../features/dynamictabs/reducers/index' /// <<== HERE
import userReducer from '../v2/store/users/user.slice'
import settingsReducer from '../v2/store/settings/settings.slice'

const defaultRootStorageConfig = {
  key: 'root',
  storage: storageSession,
  stateReconsiler: hardSet,
  blacklist: []
}

const immutableInvariantMiddleware = createImmutableStateInvariantMiddleware({
  ignoredPaths: ['ignoredPath', 'ignoredNested.one', 'ignoredNested.two']
})

const rootReducer = persistReducer(
  defaultRootStorageConfig,
  combineReducers({
    [apiContainer.reducerPath]: apiContainer.reducer,
    tabs: dynamicTabsReducers,
    users: userReducer,
    settings: settingsReducer,
    auth: signInSignoutReducers // <===== AND HERE, please note, the property name is the first level key in the global store
  })
)

const globalStore = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
      .concat(apiContainer.middleware)
      .concat(thunk)
      .concat(immutableInvariantMiddleware)
      // only complex async logic needs to use this, otherwise use createAsyncThunk or RTK Query
      // to let it take care of all the boilerplate code for you automatically

      .concat(listenerMiddlewareExecuter(dynamicFieldsMiddleware)),
  devTools: process.env.NODE_ENV !== 'production'
})
setupListeners(globalStore.dispatch)

/// ////////////////////////////////////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////////////////////////////////////

const globalPersistor = persistStore(globalStore)

export {
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary,
  globalPersistor,
  globalStore,
  Provider as ReduxProvider,
  PersistGate
}
